<template>
  <div>
    <nav class="breadcrumb_box" aria-label="breadcrumb" v-if="PostData">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page" v-if="PostData.Category"><router-link
              :to="{ name: 'Category', params: { CId: PostData.Category.CId } }">{{ PostData.Category.CategoryName
              }}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">{{ PostData.Post.Title }}</li>
        </ol>
      </div>
    </nav>
    <div class="wrapper list_main" v-if="PostData">
      <section class="main_box">
        <div class="container">
          <div class="title_box">
            <h2>{{ PostData.Post.Title }}</h2>
          </div>
          <div class="social_box">
            <div class="social">
              <a :href="PostData.ShareUrl_Facebook" target="_blank" :title="$t('分享至Facebook, 另開新視窗')">
                <img src="img/social_fb.svg" alt="">
              </a>
              <a :href="PostData.ShareUrl_Twitter" target="_blank" :title="$t('分享至Twitter, 另開新視窗')">
                <img src="img/social_twitter.svg" alt="">
              </a>
              <a :href="PostData.ShareUrl_Line" target="_blank" :title="$t('分享至Line, 另開新視窗')">
                <img src="img/social_share.svg" alt="">
              </a>
              <a href="javascript:void(0)" :title="$t('列印')" @click="print()">
                <img src="img/social_print.svg" alt="">
              </a>
            </div>
            <p class="time">{{ PostData.Post.PublicStartTime | timeString("YYYY/MM/DD") }}</p>
          </div>
          <div class="carousel" v-if="Slideshows">
            <slick class="carousel_main" :options="{
              dots: true,
            }">
              <div style="border-radius: 10px; overflow: hidden; padding-bottom: 56.25%; position: relative;" v-for="(Slideshow, index) in Slideshows" :key="index">
                <img :src="PostData.SiteUrl + Slideshow.Url" :alt="Slideshow.DisplayName" />
              </div>
            </slick>
          </div>
          <div class="text" v-html="PostData.Post.Content">
          </div>
          <hr class="line" v-if="Attachments">
          <div class="download_box" v-if="Attachments">
            <h3>{{ $t('檔案下載') }}</h3>
            <a href="javascript:void(0)"
              @click="gotoUrl(PostData.SiteUrl + '/Platform/GCIT/Download?FId=' + Attachment.FId, true)"
              :title="Attachment.DisplayName" v-for="Attachment in Attachments">{{ Attachment.DisplayName }}</a>
          </div>
        </div>
      </section>
    </div><!-- wrapper -->
  </div>
</template>
<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "分享至Facebook, 另開新視窗": "分享至Facebook, 另開新視窗",
    "分享至Twitter, 另開新視窗": "分享至Twitter, 另開新視窗",
    "分享至Line, 另開新視窗": "分享至Line, 另開新視窗",
    "檔案下載": "檔案下載",
  },
  en: {
    "首頁": "Home",
    "分享至Facebook, 另開新視窗": "Share to Facebook, Open in new window",
    "分享至Twitter, 另開新視窗": "Share to Twitter, Open in new window",
    "分享至Line, 另開新視窗": "Share to Line, Open in new window",
    "檔案下載": "Download",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Post",
  i18n,
  components: {
    Slick,
  },
  data() {
    return {
      PostData: null,
      Attachments: null,
      Slideshows: null,
      local: "zh_tw",
    };
  },
  beforeRouteUpdate(to, from, next) {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/GCIT/Post",
        {
          params: { PId: to.params.PId, CId: to.params.CId },
        }
      )
      .then((response) => {
        this.PostData = response.data;
        if (this.PostData.Post.Attachment != "[]") {
          this.Attachments = JSON.parse(this.PostData.Post.Attachment);
        } else {
          this.Attachments = null;
        }
        if (this.PostData.Post.Slideshow != "[]") {
          this.Slideshows = JSON.parse(this.PostData.Post.Slideshow);
        } else {
          this.Slideshows = null;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    next();
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/GCIT/Post",
        {
          params: { PId: this.$route.params.PId, CId: this.$route.params.CId },
        }
      )
      .then((response) => {
        this.PostData = response.data;
        if (this.PostData.Post.Attachment != "[]") {
          this.Attachments = JSON.parse(this.PostData.Post.Attachment);
        }
        if (this.PostData.Post.Slideshow != "[]") {
          this.Slideshows = JSON.parse(this.PostData.Post.Slideshow);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("yllib_main_lang")) {
      i18n.locale = $cookies.get("yllib_main_lang");
      this.local = $cookies.get("yllib_main_lang");
    } else {
      i18n.locale = $cookies.get("yllib_main_lang");
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
    print: function() {
      window.print();
    }
  },
};
</script>
